import { clsx as i } from "clsx";
import { jsx as s, jsxs as e } from "react/jsx-runtime";
var p = "_pill_2y5ao_1", m = { pill: p }, _ = ({ className: r, label: a, Icon: l }) => /* @__PURE__ */ e("span", {
  className: i(m.pill, r),
  children: [l && /* @__PURE__ */ s(l, { size: 12 }), a]
});
export {
  _ as t
};
